import { AuthenticationMethod } from "../../../../src/Core/Common/Enums";
import { IUserDefaultSettingsStates } from "../../../../src/Core/Domain/Settings/MySettings";
import { AuthenticationProvider } from "../../../../src/Core/ViewModels/Company/Settings/CompanySettingsViewModel";

export interface IUserProfile {
    firstName: string;
    lastName: string;
    phoneNumber: string;
    extension: string;
    faxNumber: string;
    emailAddress: string;
    oldPassword: string;
    password: string;
    confirmPassword: string;
    userId: number;
    authenticationProviders: AuthenticationProvider[];
    metadata: string;
    countryCode: string;
    mobileNumber: string;
    isMobileVerify: boolean;
    userSettings: IUserDefaultSettingsStates;
}

export const initialUserProfile: IUserProfile = {
    firstName: "",
    lastName: "",
    phoneNumber: "",
    extension: "",
    faxNumber: "",
    emailAddress: "",
    oldPassword: "",
    password: "",
    confirmPassword: "",
    userId: 0,
    authenticationProviders: [],
    metadata: "",
    countryCode: "",
    mobileNumber: "",
    isMobileVerify: false,
    userSettings: {
        userId: 0,
        authenticationMethodSettings: {
            defaultAuthenticationMethod: AuthenticationMethod.ACCESSCODE,
        },
    },
};

export interface IModalProps {
    index: number;
    caption: string;
    route: string;
    showState?: boolean;
    onHide: (index: number) => void;
}

export interface IOTPState {
    mfaOTPLength: number;
    isOTPValid: boolean;
}
